import { Box, Item, Text } from '@factorialco/deprecated-design-system'
import {
  SettingsPayrollConceptFragment,
  SettingsStepsLegalEntityFragment,
} from 'generated/resources/graphql'
import { keyBy } from 'lodash'

import { LevelItem } from 'modules/payroll_integrations_datev_lauds/components/SettingsSteps/LevelItem'
import { upsertCompensationMappings } from 'modules/payroll_integrations_datev_lauds/components/SettingsSteps/Steps/helper'
import { DatevMapping, DatevWizardData } from 'modules/payroll_integrations_datev_lauds/lib/types'

interface SalaryTypesByLegalEntityProps {
  data: DatevWizardData
  onMappingChanged: (mappings: DatevMapping[]) => void
  legalEntity: SettingsStepsLegalEntityFragment
  payrollConcepts: SettingsPayrollConceptFragment[]
}

export const SalaryTypesByLegalEntity = ({
  legalEntity,
  payrollConcepts,
  data,
  onMappingChanged,
}: SalaryTypesByLegalEntityProps) => {
  const legalEntityName = legalEntity.legalName

  const salaryTypeOptions: Item[] = JSON.parse(
    data.answers[`salary_types_${legalEntity.id}`] ?? '[]'
  )
  const mappings: DatevMapping[] = data.sources?.compensations?.mappings ?? []
  const legalEntityId = legalEntity.id.toString()
  const mappingsById = keyBy(
    mappings.filter((mapping) => mapping?.meta?.legal_entity_id === legalEntityId),
    'factorial_id'
  )

  const modifiedSalaryTypeOptions = salaryTypeOptions.map((option) => ({
    value: option.value,
    label: `${option.value} - ${option.label}`,
  }))

  const findSelection = (compensationId: string) => {
    const mapping = mappingsById[compensationId]

    if (!mapping) return ''
    return (
      modifiedSalaryTypeOptions.find((option) => option.value === mapping.datev_id)?.label || ''
    )
  }

  const setFormValues = (value: string, itemId: string) => {
    const newMappings = upsertCompensationMappings(mappings, value, itemId, legalEntityId)
    onMappingChanged(newMappings)
  }

  return (
    <Box gap="s24">
      {legalEntityName && <Text.Header2>{legalEntityName}</Text.Header2>}

      {payrollConcepts.map((concept) => (
        <LevelItem
          key={concept.id.toString()}
          name={concept.label}
          selectedValue={findSelection(concept.id.toString())}
          options={modifiedSalaryTypeOptions}
          onSelect={(value, _label) => setFormValues(value, concept.id.toString())}
        />
      ))}
    </Box>
  )
}
